import { useState } from 'react'

export default function LazyImagePreview({
    src,
    alt,
}: {
    src: string
    alt: string
}) {
    const [loaded, setLoaded] = useState(false)

    const handleImgLoaded = () => setLoaded(true)

    return (
        <div className="w-full aspect-square bg-stone-800">
            <img
                src={src}
                alt={alt}
                className={`w-full h-full duration-200 ${
                    loaded ? 'opacity-100' : 'opacity-0'
                }`}
                onLoad={handleImgLoaded}
            />
        </div>
    )
}
